import { view, cssGenerator } from '@yola/ws-sdk';
import { LINE_HEIGHT_CLASS_NAME } from '../constants/responsive-class-names';

const { MARGIN_TOP, MARGIN_BOTTOM } = cssGenerator.constants.attributes;

const removeLineAndParagraphSpacingFromNode = (node, breakpoint) => {
  node.removeAttribute(MARGIN_TOP);
  node.removeAttribute(MARGIN_BOTTOM);

  const currentClass = node.getAttribute('class') || '';
  const cleanedClass = view.helpers.removeResponsiveClasses({
    currentClass,
    className: LINE_HEIGHT_CLASS_NAME,
    breakpoint,
  });

  if (cleanedClass !== currentClass) {
    node.setAttribute('class', cleanedClass.trim());
  }
};

export default removeLineAndParagraphSpacingFromNode;
